"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Music = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Music = function Music(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Music_svg__Music_svg__clip0_17460_91630)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 108 0a8 8 0 000 16zm2.727-12.938c.038-.007.36-.058.396-.06.24-.019.376.12.376.347v6.243a1.99 1.99 0 01-.042.486 1.158 1.158 0 01-.218.454 1.26 1.26 0 01-.41.335 1.776 1.776 0 01-.52.167c-.262.06-.535.072-.802.036a1.177 1.177 0 01-.54-.243 1.049 1.049 0 01-.276-.33.932.932 0 01-.032-.802c.056-.128.14-.246.249-.345.136-.123.302-.218.485-.276a5.63 5.63 0 01.824-.185l.29-.051a.53.53 0 00.325-.147.438.438 0 00.09-.326V5.449c0-.223-.113-.284-.354-.243l-3.87.689c-.21.044-.282.105-.282.334V10.5a2.02 2.02 0 01-.05.484 1.157 1.157 0 01-.218.454 1.27 1.27 0 01-.41.335c-.16.082-.337.14-.52.17a2.23 2.23 0 01-.802.035 1.18 1.18 0 01-.54-.244 1 1 0 01-.375-.728.98.98 0 01.316-.75 1.33 1.33 0 01.485-.276 5.63 5.63 0 01.824-.184l.29-.052a.53.53 0 00.325-.146.441.441 0 00.098-.324v-4.92c0-.045.003-.089.01-.133A.387.387 0 016 3.966a.663.663 0 01.277-.11h.002l4.449-.794z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Music_svg__Music_svg__clip0_17460_91630"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};

exports.Music = Music;
var _default = Music;
exports.default = _default;